export default {"src":"/_next/static/media/dash0.3e6ae369.svg","height":20,"width":105,"blurWidth":0,"blurHeight":0};